import React, { useContext } from "react";
import PermissionContext from "@/context/permissionContext";

type Props = {
  permissionRequired: string;
  children: any;
  fallback?: React.ReactNode;
};

// This component is meant to be used everywhere a restriction based on user permission is needed
const Restricted: React.FunctionComponent<Props> = ({
  permissionRequired,
  children,
  fallback = null,
}) => {
  // We "connect" to the provider thanks to the PermissionContext
  const { isAllowedTo } = useContext(PermissionContext);

  // If the user has that permission, render the children
  if (isAllowedTo(permissionRequired)) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};

export default Restricted;
